import { reactive } from "vue";
import store from "../../../store";
import { createLoading } from "../../../utils/loading";
import { createManageExportCsv, createPage } from "../../../utils/page";
import { createConditionAction } from "./service-log.condition";
import { createColumns } from "./service-log.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/ws/serviceLog";
export const routerPrefix = "service-logs";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const onSearch = ({ page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where, sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const initState = ({ props }) => {
    const menuContext = props.menuContext;
    state.manages = [createManageExportCsv({ menuContext })];
    state.manageExtras = [];
    state.rowActions = [];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({ options: { select: ["*", "refUser.*"], sort: [{ name: "createDate", type: "DESC" }] } }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
